// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__5hgQA","footerMenu":"Footer_footerMenu__hf2iQ"};